<template>
    <div class="login_page_wrap">
        <div class="row m-0">
            <div class="col-md-6 p-0">
                <div class="login_left_side">
                    <router-link v-bind:to="'/'">
                        <img src="../../assets/images/login-logo.png">
                    </router-link>
                </div>
            </div>
            <div class="col-md-6 p-0">
                
                <div class="login_right_side">
                    <form v-on:submit.prevent="forgot_password">
                        <h4>Forget Password</h4>
                        <div v-if="success_message" class="alert alert-success alert-dismissible fade show" role="alert">
                            <strong>{{ success_message }}</strong>
                            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div v-if="errors.message" class="alert alert-danger alert-dismissible fade show" role="alert">
                            <ul>
                                <li>{{errors.message}}</li>
                            </ul>
                        </div>

                        <div class="form_field_block">
                            <label>Email Address</label>
                            <input type="email" v-model="email" name="email" class="form-control" v-bind:class="{required : isInputValid(errors.email)}">
                                <span v-if="errors.email">{{ getError(errors.email) }}</span>
                        </div>

                        
                        <div class="login_button-wrapper">
                            <button type="submit" class="login_btn">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import axios from 'axios'
import router from '../../router'
import EventBus from '../EventBus'

export default{
    data(){
        return {
            email: '',
            success_message:null,
            errors:[]
        }
    },

    methods:{
        isInputValid(input){
            return (typeof input != "undefined" && input!="");
        },
        getError(input){
                return (typeof input != "undefined" && input!="") ? input[0] : '';
            },
        forgot_password() {
            this.errors = [];
            var _self = this;
            axios.post(this.$hostname+'/api/forget-password',
            {
              email:this.email,
            })
            .then((res) => {
                console.log(res,"sdfasdfsfsdfsdf")
                this.email = ''
                _self.success_message = 'Please check your email to reset password';
                return false;
            })
            .catch((error) => {
                this.errors = error.response.data;
                console.log(this.errors.message,"this.errors");
                        return false;
                
            })

            
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Auth/ForgetPassword.vue